import styled from 'styled-components';
import React from 'react';
import { colors, sidebarBreakpoint } from '../variables';

const HamburgerButton = styled.button`
	text-transform: uppercase;
	margin-left: 20px;
	width: 40px;
	height: 28px;
	position: relative;
	transform: rotate(0deg);
	transition: 0.3s ease-out;
	cursor: pointer;
	background: transparent;
	border: 0;
	border-radius: 0;
	outline: 0;

	&:hover span,
	&:focus span {
		background: ${colors.blue.digitalLight};
	}

	span {
		display: block;
		position: absolute;
		height: 4px;
		width: 100%;
		background: #fff;
		border-radius: 1px;
		opacity: 1;
		left: 0;
		transform: rotate(0deg);
		transition: 0.2s ease-out;

		@media (max-width: ${sidebarBreakpoint + 'px'}) {
			background: #fff;
			opacity: 1;
		}

		&:nth-of-type(1) {
			top: 0;
		}

		&:nth-of-type(2),
		&:nth-of-type(3) {
			top: 11px;
		}

		&:nth-of-type(4) {
			top: 22px;
		}
	}

	@media (min-width: ${sidebarBreakpoint + 1 + 'px'}) {
		display: none;
	}

	${props =>
		props.open &&
		`
	span {
		&:nth-of-type(1), &:nth-of-type(4) {
			top: 14px;
			width: 0%;
			left: 50%;
		}

		&:nth-of-type(2) {
			transform: rotate(45deg);
		}

		&:nth-of-type(3) {
			transform: rotate(-45deg);
		}
	}
`};
`;

class Hamburger extends React.Component {
	render() {
		return (
			<HamburgerButton {...this.props}>
				<span />
				<span />
				<span />
				<span />
			</HamburgerButton>
		);
	}
}

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/TopBar/Hamburger.js